<template>
  <unicom-linha class="unicom-linha linha-embaixo">
    <unicom-coluna sm="12">
      <!-- <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Hospital Dia</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna> -->

      <unicom-linha justificarItem="center">
        <unicom-coluna sm="3" :class="espacamentoMobile">
          <div id="titulo">
            Quais tipos de procedimentos oferece?
          </div>
        </unicom-coluna>
      </unicom-linha>
      <unicom-linha justificarItem="center" class="procedimentos">
        <unicom-coluna sm="4" :class="espacamentoMobile">
          <unicom-campo-texto
            :maxCaracteres="1500"
            ladoIcone="direito"
            clickIcone
            colorPlaceholder="#9E9E9E"
            placeholder="Tipos de procedimentos"
            v-model="payload.especialidadesOferecidas"
          />
        </unicom-coluna>
      </unicom-linha>
      <!-- <unicom-coluna sm="3" :class="espacamentoMobile">
      <single-select
        @input="atualizarServicoPublico"
        :propsSingleSelect="{
          placeholder: 'Público',
          options: listaPublicoAlvo,
          'track-by': 'id',
          label: 'tipoServicoPublico'
        }"
        :value="payload.tipoServicoPublico"
       
      /> -->
      <!-- </unicom-coluna> -->
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import SharedMixin from "./SharedMixin.js";
// import SingleSelect from "@/views/RecursosPropriosQuestionarios/shared/Singleselect.vue";

export default {
  mixins: [SharedMixin],
  components: {
    // SingleSelect
  },
  data() {
    return {
      payload: {
        tipoServico: "Hospital Dia",
        especialidadesOferecidas: "",
        tipoServicoPublico: []
      }
    };
  },
  methods: {},
  watch: {
    "payload.especialidadesOferecidas": "emitir",
    "payload.tipoServicoPublico": "emitir",
    dadosServidor(newVal) {
      if (newVal.especialidades.length > 0) {
        newVal.especialidades.forEach(especialidade => {
          if (
            especialidade.tipoServico.tipoServico === this.payload.tipoServico
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidade",
              especialidade.tipoServicoEspecialidade
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (newVal.servicos.length > 0) {
        newVal.servicos.forEach(servico => {
          if (
            servico.tipoServico.tipoServico === this.payload.tipoServico &&
            (servico.tipoServicoPublico || servico.especialidadesOferecidas)
          ) {
            this.clickSwitch = true;
            this.preencheCampo("publico", servico.tipoServicoPublico);
            this.preencheCampo(
              "especialidades oferecidas",
              servico.especialidadesOferecidas
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.unicom-linha {
  margin-bottom: 24px;
}
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
#titulo {
  font-size: 15px;
  padding-top: 8px;
  text-align: center;
}

.procedimentos {
  margin: 1rem 0;
}
</style>
